import { render, staticRenderFns } from "./index.vue?vue&type=template&id=27512481&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=27512481&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27512481",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonEducationBrandsBlock: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonEducationBrandsBlock.vue').default})
